<div *ngIf="show" class="page-loading">
  <img src="assets/img/oval.svg" class="loading-icon" />
</div>